import { exchangeMicLabels } from '@cmg/common';
import { createValueFormatter } from '@cmg/data-grid';
import isNil from 'lodash/isNil';
import sortBy from 'lodash/sortBy';

import { OfferingSetupExchangeMic } from '../../../../../../graphql/__generated__';
import type {
  CalendarGridColDef,
  CalendarGridRowData,
  CalendarGridSetFilterParams,
} from '../../CalendarGrid.model';

export type Value = CalendarGridRowData['exchangeMic'];

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => {
    if (isNil(value)) {
      return '-';
    }

    const label = exchangeMicLabels[value];
    return label?.shortName ?? value;
  },
});

const exchangeMicColDef: CalendarGridColDef<Value> = {
  field: 'exchangeMic',
  headerName: 'Exchange',
  width: 115,
  type: 'text',
  filter: 'agSetColumnFilter',
  filterParams: {
    suppressSorting: true,
    values: sortBy(Object.values(exchangeMicLabels), ['shortName']).map(
      ({ name }) => name as OfferingSetupExchangeMic
    ),
    valueFormatter,
  } satisfies CalendarGridSetFilterParams<Value>,
  valueFormatter,
};

export default exchangeMicColDef;
